import React, { forwardRef } from 'react';
// @mui
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { TransitionProps } from '@mui/material/transitions';
// components
import Iconify from 'src/components/iconify';
// issued
import { useCheckById } from 'src/hooks/profiles/use-check-by-check-code';
import CheckSetting from 'src/sections/profiles/components/check-settings';
import { DialogContent } from '@mui/material';
import { useLocales } from 'src/locales';
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const Transition = forwardRef(
    (
        props: TransitionProps & {
            children: React.ReactElement;
        },
        ref: React.Ref<unknown>
    ) => <Slide direction="up" ref={ref} {...props} />
);

interface CheckDialogProps {
    open: boolean;
    onClose: () => void;
    check_id: number;
}

const ViewCheck: React.FC<CheckDialogProps> = ({ open, onClose, check_id }) => {

    const checkHolder = useCheckById(check_id);
    const { check, company, rib, carnet, canEdit, isLoading } = checkHolder;
    const { t } = useLocales();

    if (isLoading || !check) return <LoadingScreen />;

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={() => { onClose() }}
            TransitionComponent={Transition}
        >
            <AppBar position="relative" color="default">
                <Toolbar>
                    <IconButton color="inherit" edge="start" onClick={() => { onClose() }}>
                        <Iconify icon="mingcute:close-line" />
                    </IconButton>

                    <Typography variant="h6" sx={{ flex: 1, ml: 2 }}>
                        {t('m.t.viewCheck')}
                    </Typography>

                    <Button autoFocus color="inherit" variant="contained" onClick={() => { onClose() }}>
                        {t('common.button.action.close')}
                    </Button>
                </Toolbar>
            </AppBar>
            <DialogContent sx={{ padding: '20px' }}>
                <CheckSetting ch_e_ck={check} comp_any={company} r_i_b={rib} car_net={carnet} canEdit={canEdit} />
            </DialogContent>
        </Dialog>
    );
}
export default ViewCheck;
